import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { TokenService } from 'src/app/services/token.service';
import { UsuarioService } from 'src/app/services/usuario.service';
@Component({
    selector: 'app-token-lancamento',
    templateUrl: './token-lancamento.component.html',
    styleUrls: ['./token-lancamento.component.css'],
    standalone: false
})
export class TokenLancamentoComponent implements OnInit {
  form!: UntypedFormGroup;
  idToken = null;
  dataTokenAtt = null;
  parceiros: Array<{ label: string; value: string; }> = [];
  habilidades: any = [];

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private tokenService: TokenService,
    private usuarioService: UsuarioService
  ) { 
    this.form = this.newForm();

    this.route.params.subscribe(res => this.idToken = res.id);
  }

  ngOnInit(): void {
    if (this.idToken !== undefined) {
      this.tokenService.detalhar(this.idToken).subscribe((p: any) => {
        let item = p.data.token;
        this.dataTokenAtt = item;
        this.form.get('id').setValue(item.id);
        this.form.get('tokenable_id').setValue(item.tokenable_id);
        this.form.get('name').setValue(item.name);
        this.form.get('abilities').setValue(item.abilities);
      });
    } else {
      this.form.reset();
    }
    this.getParceiros();
    this.getHabilidades();
  }

  newForm() {
    return new UntypedFormGroup({
      id: new UntypedFormControl(''),
      name: new UntypedFormControl('', [Validators.required]),
      tokenable_id: new UntypedFormControl('', [Validators.required]),
      abilities: new UntypedFormControl([], [Validators.required]),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.idToken !== undefined) {
        let dadosEdicao = this.form.value;

        //TODO: Atualização de informações não será desenvolvida por enquanto
        this.tokenService.atualizar(this.idToken, dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/tokens']);
          this.message.remove(id);
          this.message.success('As informações do token foram atualizadas com sucesso!');
        });

      } else {
        this.tokenService.criar(this.form.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/tokens']);
          this.message.success('O token foi criado com sucesso!');
        });
      }

    } else {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
    }
  }

  getParceiros() {
    this.usuarioService.all(1, '', 10000, '&tipo=PARCEIRO').subscribe((u: any) => {
      u.data.usuario.data.forEach(item => {
        if(item['ativo'] === 1){
          this.parceiros.push({
            label: item['name'],
            value: item['id']
          });
        }
        
      });
    });
  }

  getHabilidades() {
    this.tokenService.habilidades().subscribe((u: any) => {
      u.data.habilidades.forEach(item => {
        this.habilidades.push({
          label: item,
          value: item
        });
      });
    });
  }

}
